import React from "react";
import { Box, Typography } from "@mui/material";
import ThemeToggle from "./ThemeToggle";
import Navbar from "./Navbar";

const Layout = ({ title, icon, children, hideNavbar=false }) => {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            mb: 2,
        }}>
        <Box
        sx={{
            borderBottom: 1,
            p: 2,
            backgroundColor: 'var(--primary-color)',
            color: 'var(--background-color)',
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
        }}>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
            }}>
            <Box sx={{ mr: 2 }}>
                { !hideNavbar ? <Navbar /> : null}
            </Box>
            {
            icon ? icon : null
            }
            <Typography
            sx={{
                fontWeight: 'bold',
                fontSize: 24,
            }}
            >
                {title}
            </Typography>
            </Box>

            <Box>
                <ThemeToggle />
            </Box>
        </Box>
        <Box
        sx={{
            pl: 3,
            pr: 3,
            pt: 1,
        }}
        >
            {children}
        </Box>
        </Box>
    );
}

export default Layout;
